import PropTypes from 'prop-types';
import React from 'react';
import { Section, Button, Status, Icon, Input, TooltipHelp } from '@weezevent/nacre';
import { FileContext } from './uploadImageZoneGemino';
import { useTranslation } from 'react-i18next';

const LineImage = ({ src, onDelete, labelButton, additionalText, className, onClick, onInputChange, name }) => {
    const { t } = useTranslation();

    const { fileType } = React.useContext(FileContext);
    const _className = `wz-line-image${className ? ` ${className}` : ''}`;
    const splitSRC = src.split('/');
    const splitIMG = splitSRC[splitSRC.length - 1].split('.');
    let nameIMG = splitIMG[0];
    let extensionIMG = splitIMG.length > 1 ? splitIMG[splitIMG.length - 1] : null;
    if (src.includes('unsplash')) {
        nameIMG = splitSRC[splitSRC.length - 1].split('?')[0];
        extensionIMG = 'unsplash';
    }

    const itemName = fileType === 'file' ? (name !== src ? name : decodeURI(nameIMG)) : name || decodeURI(nameIMG);
    const [inputValue, setInputValue] = React.useState(itemName);
    return (
        <Section className={onClick && 'wz-line-image__click'}>
            <div className={_className}>
                <div className="wz-line-image__container" onClick={onClick}>
                    {src && fileType === 'image' ? (
                        <div className="wz-line-image__image">
                            <img alt="Selected" src={src} />
                        </div>
                    ) : (
                        <Icon name="folder-open" size="huge" />
                    )}

                    <div className="wz-line-image__text">
                        <div className="wz-line-image__filename">
                            <div className="wz-line-image__name">{decodeURI(nameIMG)}</div>
                            {onInputChange && (
                                <Input
                                    value={inputValue}
                                    onChange={(e, { value }) => setInputValue(value)}
                                    onBlur={() => onInputChange(inputValue)}
                                    rightIcon={<TooltipHelp title={t('ticket.event.minisite.block.type.download-files.help-text')} />}
                                />
                            )}
                            {extensionIMG && <Status color="blue" text={extensionIMG} />}
                        </div>
                        {additionalText && <div className="wz-line-image__additional">{additionalText}</div>}
                    </div>
                </div>
                {onDelete && (
                    <div className="wz-line-image__actions">
                        <Button onClick={onDelete}>{labelButton}</Button>
                    </div>
                )}
            </div>
        </Section>
    );
};

LineImage.propTypes = {
    src: PropTypes.string.isRequired,
    onDelete: PropTypes.func,
    className: PropTypes.string,
    labelButton: PropTypes.node,
    additionalText: PropTypes.node,
    onClick: PropTypes.func,
    onInputChange: PropTypes.func,
    name: PropTypes.string
};

LineImage.defaultProps = {
    onDelete: null,
    className: null,
    labelButton: 'Delete',
    additionalText: null,
    onClick: null,
    onInputChange: null,
    name: null
};

export default LineImage;
